<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12">
                    <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>Bejelentkezés</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" @submit.prevent="login">
                            <v-text-field label="Felhasználónév" v-model="username" :rules="required" name="username" prepend-icon="person" type="text" required></v-text-field>
                            <v-text-field id="password" label="Jelszó" v-model="password" :rules="required" name="password" prepend-icon="lock" type="password" required></v-text-field>
                            <v-btn color="primary" large type="submit"> Bejelentkezés </v-btn>
                            <v-alert v-if="errors.username" type="error" class="mt-4">{{ errors.username[0] }}</v-alert>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Login",

        data() {
            return {
                valid: true,
                username: "",
                password: "",
                required: [
                    v => !!v || 'A mező kitöltése kötelező!'
                ]
            };
        },

        methods: {
            login: function() {
                if(this.$refs.form.validate()) {
                    let username = this.username;
                    let password = this.password;
                    this.$store
                        .dispatch("auth/login", { username, password })
                        .then(() => this.$router.push("/"))
                        .catch(err => console.log(err));
                }
            },
        },
    }
</script>

<style scoped>

</style>
